import { Reveal, Eyebrow } from "./Reveal";

const FAQS = [
  {
    q: "How often should I review my home loan?",
    a: "At least once a year. Rates change, your income changes and your goals change — an annual home loan review checks your rate against the market and looks for ways to pay your home loan off sooner. Toro Finance does it free of charge.",
  },
  {
    q: "Is refinancing worth it?",
    a: "It can be. Refinancing is worth it when a new loan's rate, fees and features beat your current one by enough to outweigh the switching costs. We compare refinance home loan options across the market and show you the numbers before you decide.",
  },
  {
    q: "Do you help with investment property loans?",
    a: "Yes — the investment property loan is core to what we do. We structure lending around your plans, whether it's your first investment property or part of a bigger portfolio.",
  },
];

const Faq = () => (
  <section id="faq" className="bg-ivory py-24 text-ink lg:py-32" data-testid="faq-section">
    <div className="mx-auto max-w-4xl px-6 lg:px-12">
      <Reveal>
        <Eyebrow>Good to know</Eyebrow>
        <h2 className="mt-4 font-display text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl">
          Questions people
          <span className="italic text-eucalyptus"> actually ask.</span>
        </h2>
      </Reveal>
      <div className="mt-12 divide-y divide-ink/10 border-y border-ink/10">
        {FAQS.map((f, i) => (
          <Reveal key={f.q} delay={0.08 * i}>
            <div className="py-8" data-testid={`faq-item-${i + 1}`}>
              <h3 className="font-display text-2xl font-medium text-ink sm:text-3xl">
                {f.q}
              </h3>
              <p className="mt-4 text-base leading-relaxed text-ink/65">{f.a}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Faq;
